export default function loadInputGroupQuantity($inputGroup: HTMLDivElement) {
	const $input = $inputGroup.querySelector<HTMLInputElement>('input[type="number"]');
	if (!$input) return;

	const [$buttonDecrease, $buttonIncrease] = $inputGroup.querySelectorAll<HTMLButtonElement>('button');
	if (!$buttonDecrease || !$buttonIncrease) return;

	$buttonDecrease.addEventListener('click', () => {
		if ($input.valueAsNumber > 1) {
			$input.value = ($input.valueAsNumber - 1).toString();
		}
	});

	const max = Number.isNaN(Number.parseInt($input.max)) ? Infinity : Number.parseInt($input.max);

	$buttonIncrease.addEventListener('click', () => {
		if ($input.valueAsNumber < max) {
			$input.value = ($input.valueAsNumber + 1).toString();
		}
	});
}
